// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1667":"683a78b2ba8de5f6","5149":"503e53a493c0edc8"}[chunkId] + ".css";
};